import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { IFiltersSelectionDto } from "../../types/dto";
import { advancedSearchFilteringQueryKeys } from "../queryKeyFactory";
import type { IFiltersSelectionOptions } from "../types";

export const createFilterSelectionQuery = <TData = IFiltersSelectionDto>(options?: IFiltersSelectionOptions<TData>) =>
    queryOptions<IFiltersSelectionDto, Error, TData>({
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: advancedSearchFilteringQueryKeys.filtersSelection(),
        placeholderData: keepPreviousData,
        queryFn({ signal }) {
            return salesApiService.advancedSearchFiltering.fetchFiltersSelection({ cancellation: signal });
        },
        select: options?.select,
    });
